// @flow

import { put, takeEvery } from 'redux-saga/effects'
import { getAllTags } from '../fetch/tags'
import { addTags } from '../stores/tags'

export function* fetchTagsSaga(): Generator<*, void, *> {
  yield takeEvery('FETCH_TAGS', function*() {
    const tags = yield getAllTags()
    if (tags) {
      yield put(addTags(tags))
    }
  })
}



// WEBPACK FOOTER //
// ./src/sagas/fetchTags.js